import * as Yup from "yup";

const CheckValidationSchema = Yup.object({
  organizationName: Yup.string().required("This field can not be empty"),
  shulwebsitelink: Yup.string().required("This field can not be empty"),

  phoneNumber: Yup.array().of(
    Yup.object().shape({
      phone_number: Yup.string().required("This field can not be empty"),
      contact_name: Yup.string().required("This field can not be empty"),
    })
  ),
  name: Yup.string().required("This field can not be empty"),
  billingEmailAddress: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("This field can not be empty"),
  emailAddress: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("This field can not be empty"),
  address: Yup.string().required("This field can not be empty"),
});

export default CheckValidationSchema;
